function withMfaFeatureFlag<T>(
  MfaComponent: React.ComponentType<T>
): React.ComponentType<T> {
  const AugmentedComponent = (props: T): JSX.Element => {
    return <>{<MfaComponent {...(props as T)} />}</>;
  };

  return AugmentedComponent;
}

export { withMfaFeatureFlag };
